import { render, staticRenderFns } from "./generalWarehouse.vue?vue&type=template&id=327e9f13&"
import script from "./generalWarehouse.vue?vue&type=script&lang=js&"
export * from "./generalWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./generalWarehouse.vue?vue&type=style&index=0&id=327e9f13&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports